import { useSelector } from 'react-redux';

// ==============================|| WORDMARK LOGO (theme-aware) ||============================== //

const Logo = () => {
  const navType = useSelector((state) => state.customization.navType);
  const isDark = navType === 'dark';

  // "Sama" stays navy in light, brightens on dark surfaces for contrast.
  const samaColor = isDark ? '#aab2f5' : '#2b328f';
  const forecasterColor = '#ed2526'; // brand red reads well on both

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <p
        style={{
          margin: '0',
          fontSize: '24px',
          fontWeight: 'bold',
          fontFamily: 'Marcellus, serif',
          letterSpacing: '0.3px',
          color: samaColor,
          transition: 'color .25s ease'
        }}
      >
        Sama
        <span style={{ color: forecasterColor }}>
          Forecaster<sup style={{ fontSize: '12px' }}>TM</sup>
        </span>
      </p>
    </div>
  );
};

export default Logo;
